module.exports = __webpack_public_path__ + "static/media/comet.25d55a05.svg";